'use strict';

(function () {
  'use strict';

  angular.module('referrals').component('referralList', {
    bindings: {
      referralSettings: '<',
      selectFn: '<'
    },
    templateUrl: 'referrals/templates/referralList.html',
    controller: ReferralListCtrl
  });

  ReferralListCtrl.$inject = ['$log'];

  function ReferralListCtrl($log) {
    var vm = this;
    vm.resolveFormName = _resolveFormName;

    vm.$onInit = function () {
      _initList();
    };

    function _initList() {

      $log.debug('activating ReferralListCtrl');
      vm.referralSettingsList = [];
      vm.referralSettings.forEach(function (rs) {
        if (rs.settings.menuEnabled) {
          if (rs.settings.accessLevel === 'CODE') {
            rs.settings.accessCodes.forEach(function (ac) {
              vm.referralSettingsList.push(angular.extend({}, rs, {
                accessCode: ac
              }));
            });
          } else {
            vm.referralSettingsList.push(rs);
          }
        }
      });
    }

    function _resolveFormName(form) {
      if (!form.accessCode && !form.settings.accessCodeGroup) {
        return form.organization.name;
      } else if (!form.accessCode && form.settings.accessCodeGroup) {
        return form.settings.accessCodeGroup.name.split('-').pop();
      } else if (form.accessCode) {
        return form.accessCode.name.split('-').pop();
      }
      return '';
    }
  }
})();